import { styled } from "@mui/system";
import { Button } from "@mui/material";

const SecondaryButton = styled(Button)`
  && {
    background: transparent;
    color: #004795;
    border: 1.5px solid #004795;
    border-radius: 50px;
    text-transform: none; 
    font-weight: 500;
    font-size: 1rem;
    min-width: 18rem;
    width: 14rem;
    padding: 0.8rem 2.5rem;
    box-shadow: none;

    &:hover {
      background-color: rgba(0, 71, 149, 0.04); 
      border: 1.5px solid #003366;
      color: #003366;
    }

    &:disabled {
      border-color: #e0e0e0;
      color: #a0a0a0;
    }
     @media (max-width: 600px) {
      width: 100%;
      min-width: 0;
    }
  }
`;

export default SecondaryButton;